import PazientiList from "./components/PazientiList.vue";
import PazientiEdit from "./components/PazientiEdit.vue";

export default {
    PazientiList,
    PazientiEdit,
};
